import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-help-vessels',
    templateUrl: './help-vessels.component.html',
    styleUrls: ['./help-vessels.component.css'],
    standalone: false
})
export class HelpVesselsComponent implements OnInit {

  constructor() {

  }

  ngOnInit(): void {

  }

}
